module.exports = __webpack_public_path__ + "media/tags/smartsearch/search_icon_sp-516509fd88977b0545fac825b873eac3.png";